// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessHomeMobility = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      d="M19.13 9.5h1.61l-1.327-.912-5.945-4.087a1 1 0 0 0-1.138.004L6.66 8.454l-.566-.824 6.808-4.732L21.4 8.74V20h-1V9.79h-1v.709h-6.84l-.13.093-3.136 2.24a1.001 1.001 0 0 1-.458.179l-2.998.375-.438.054V17.5h3.024l.118-.333a2.501 2.501 0 0 1 4.716 0l.118.333H19.4v1h-6.024l-.118.334a2.501 2.501 0 0 1-4.716 0l-.118-.334H5.4a1 1 0 0 1-1-1v-3.617a1.5 1.5 0 0 1 1.314-1.488l-.062-.497.062.497 2.873-.36.125-.015.103-.074 3.164-2.26a1 1 0 0 1 .581-.186h6.57Zm-6.228-6.602ZM10.9 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    />
  </svg>
);
export default SvgBusinessHomeMobility;
